import React from "react";
import { Box } from "@mui/material";

export default function Footer() {
  return <Box component="footer" />;
}
